import React from "react";
import { Box, Paper, Typography, Divider } from "@mui/material";

interface MonthlyBreakdownProps {
  totalBookings: number;
  grossEarnings: number;
  serviceFee: number;
  serviceFeePercent: number;
  netEarnings: number;
  averagePerBooking: number;
}

const MonthlyBreakdown: React.FC<MonthlyBreakdownProps> = ({
  totalBookings,
  grossEarnings,
  serviceFee,
  serviceFeePercent,
  netEarnings,
  averagePerBooking,
}) => {
  return (
    <Paper elevation={1} sx={{ p: 3, height: "100%" }}>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 3 }}>
        Monthly Breakdown
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
        {/* Total Bookings */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Total Bookings
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {totalBookings} completed
          </Typography>
        </Box>

        {/* Gross Earnings */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Gross Earnings
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            ${grossEarnings.toFixed(2)}
          </Typography>
        </Box>

        {/* Service Fee */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Service Fee ({serviceFeePercent}%)
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600, color: "#D32F2F" }}>
            -${serviceFee.toFixed(2)}
          </Typography>
        </Box>

        <Divider />

        {/* Net Earnings */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
            backgroundColor: "rgba(23, 139, 142, 0.08)",
            borderRadius: 2,
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: 700 }}>
            Net Earnings
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: "#178B8E" }}
          >
            ${netEarnings.toFixed(2)}
          </Typography>
        </Box>

        <Divider />

        {/* Average per Booking */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Average per Booking
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            ${averagePerBooking.toFixed(2)}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default MonthlyBreakdown;
